import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect, useSelector } from 'react-redux'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { SettingOutlined } from '@ant-design/icons'
import Frame from '../../../assets/images/Frame.svg'
import EngineeringIcon from '../../../assets/images/Icons/EngineeringIcon'
import ScoutIcon from '../../../assets/images/Icons/ScoutIcon'
import LogoutApprovedIcon from '../../../assets/images/Icons/LogoutApprovedIcon'
import ProfileApprovedIcon from '../../../assets/images/Icons/ProfileApprovedIcon'
import './ProfileToggle.scss'
import Capital from '../../../assets/images/capital.png'
import { portalRedirection } from '../../../redux/investorFlowControl/investorFlowControlActions'
import { toggleInvestor, updateLocalInvestorUser } from '../../../redux/auth/authActions'
import { message } from 'antd'

const ProfileToggle = props => {
  const { profile_data } = useSelector(state => state.trackingFlowControlReducer)
  const [activeProfile, setActiveProfile] = useState(false)
  const [activeCompanyInfo, setActiveCompanyInfo] = useState(false)

  // Toggles the profile visibility.
  const handleProfileClick = () => {
    setActiveProfile(!activeProfile)
  }

  // Toggles the visibility of the company information section and navigates to the company profile page.
  const handleCompanyInfoClick = () => {
    setActiveCompanyInfo(!activeCompanyInfo)
    props.history.push('/startup/approve/profile/company-information')
  }

  // Toggles the visibility of the company information section and navigates to the company setting page.
  const handleProfileSettingClick = () => {
    setActiveCompanyInfo(!activeCompanyInfo)
    props.history.push('/startup/approve/settings/company-information')
  }

  // Handles redirection to the investor dashboard based on the status.
  const handleInvestorDashboard = () => {
    props
      .portalRedirection('startup', 'investor')
      .then(res => {
        if (res.result) {
          localStorage.setItem('investor_token', res.token)
          localStorage.setItem('userId', res.user.id)
          localStorage.setItem('startup_account', res.user.startup_account)
          if (['pending', 'rejected'].includes(res?.user?.status?.status)) {
            window.open('/investor/thankyou', '_blank')
          } else if (res?.user?.status?.status === 'incomplete') {
            window.open(`/investor/onboarding/${res?.user?.onboarding_step + 1}`, '_blank')
          } else {
            window.open('/investor/deals', '_blank')
          }
        } else {
          if (res.error === 'user is paused') {
            window.open('/suspend', '_blank')
          }
        }
      })
      .catch(err => {
        if (err?.error === 'user is paused') {
          window.open('/suspend', '_blank')
        }
      })
  }

  // Logs out the user by clearing local storage and navigating to the home page.
  const handleLogout = () => {
    localStorage.clear()
    window.location.href = '/'
  }

  return (
    <div className="profile-setting-dropdown">
      <div className="profile-setting-wrapper">
        <Dropdown isOpen={activeProfile} toggle={handleProfileClick}>
          <DropdownToggle>
            <span
              className="align-items-center justify-content-center notification-dummy"
              onClick={handleProfileClick}
            >
              {profile_data?.data?.logo ? (
                <img src={profile_data?.data?.logo} alt="profile-img" />
              ) : (
                profile_data?.data?.company_name?.charAt(0).toUpperCase()
              )}
            </span>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={handleCompanyInfoClick}>
              <ProfileApprovedIcon />
              Profile
            </DropdownItem>
            <DropdownItem
              onClick={() => {
                props
                  .portalRedirection('startup', 'recruit')
                  .then(res => {
                    if (res.result) {
                      localStorage.setItem('recruit_token', res.token)
                      localStorage.setItem('is_startup', 'true')
                      window.open(`/recruit/onboarding/${res.user.onboarding_step + 1}`, '_blank')
                    } else {
                      if (res.error === 'user is paused') {
                        window.open('/suspend', '_blank')
                      } else if (res.error === "You don't have account in recruit portal") {
                        message.error(res.error, 2)
                      }
                    }
                  })
                  .catch(err => {
                    if (err?.error === 'user is paused') {
                      window.open('/suspend', '_blank')
                    }
                  })
              }}
            >
              <EngineeringIcon />
              Recruit Engineers
            </DropdownItem>
            <DropdownItem
              onClick={() => {
                props
                  .portalRedirection('startup', 'scout')
                  .then(res => {
                    if (res.result) {
                      localStorage.setItem('scout_token', res.token)
                      localStorage.setItem('login_type', res.user.login_type)
                      localStorage.setItem('investor_account', res.user.investor_account)
                      window.open('/scout/invite', '_blank')
                    } else {
                      if (res.error === 'user is paused') {
                        window.open('/suspend', '_blank')
                      } else if (res.error === "You don't have account in scout portal") {
                        message.error(res.error, 2)
                      }
                    }
                  })
                  .catch(err => {
                    if (err?.error === 'user is paused') {
                      window.open('/suspend', '_blank')
                    }
                  })
              }}
            >
              <ScoutIcon />
              Scout Dashboard
            </DropdownItem>
            <DropdownItem onClick={handleProfileSettingClick}>
              <SettingOutlined />
              Settings
            </DropdownItem>
            <DropdownItem onClick={handleLogout}>
              <LogoutApprovedIcon />
              Logout
            </DropdownItem>
            {localStorage.getItem('investor_account') === true ||
            localStorage.getItem('investor_account') === 'true' ? (
              <DropdownItem onClick={handleInvestorDashboard}>
                <span className="investor-text inv-dashboard-text">
                  <img src={Frame} alt="Frame" />
                  Switch to Investor Dashboard
                </span>
              </DropdownItem>
            ) : (
              <DropdownItem
                onClick={() => {
                  window.open('/investor/signup', '_blank')
                  localStorage.setItem(
                    'userData',
                    JSON.stringify({
                      email: props?.user?.email,
                      first_name: props?.user?.first_name,
                      last_name: props?.user?.last_name,
                    }),
                  )
                }}
              >
                <span className="investor-text">
                  <img src={Capital} />
                  Sign up as an Investor
                </span>
              </DropdownItem>
            )}
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  user: state?.trackingFlowControlReducer?.profile_data?.data,
})

const mapDispatchToProps = dispatch => ({
  portalRedirection: (url, data) => {
    return dispatch(portalRedirection(url, data))
  },
  updateLocalInvestorUser: changedProperties => {
    dispatch(updateLocalInvestorUser(changedProperties))
  },
  toggleInvestorPage: () => dispatch(toggleInvestor()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProfileToggle))
